module.exports = __webpack_public_path__ + "static/media/good-america.d0a9022c.jpg";